import { useEffect, useState } from "react";
import { isLoaderComplete, onLoaderComplete } from "./loaderState";

/**
 * Returns whether the intro preloader has finished.
 * Starts as the current module value, then flips to true the moment the
 * loader completes (immediately if it already has, e.g. on route changes).
 */
export const useLoaderComplete = () => {
  const [complete, setComplete] = useState(isLoaderComplete);

  useEffect(() => onLoaderComplete(() => setComplete(true)), []);

  return complete;
};

export default useLoaderComplete;
